// extracted by mini-css-extract-plugin
export default {"imgContainer":"imgContainer___vi7li","clickable":"clickable___NRWVk"};